import React, { useEffect, useState } from "react";

import Seta from "../../../../Assets/images/seta.png";

import {
	Document,
	Font,
	Image,
	Page,
	StyleSheet,
	Text,
	View,
} from "@react-pdf/renderer";

import Roboto from "../../../../Assets/fonts/Roboto-Bold.ttf";
import { VendaService } from "../../../../service/venda_service";

Font.register({
	family: "Roboto bold",
	format: "truetype",
	src: Roboto,
});

const styles = StyleSheet.create({
	page: {
		paddingLeft: "10px",
		paddingRight: "10px"
	},
	body: {
		marginTop: "5px",
		width: "100%",
		height: "100%",
		backgroundColor: "white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	topEtiquetaContainer: {
		width: "100%",
		height: "40px",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexDirection: "row",
		padding: "0",
		margin: "0",
	},
	logoEmpressaContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "50px",
		width: "90px",
	},
	codBarContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	bottonEtiquetaContainer: {
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "start",
		justifyContent: "start",
		flexDirection: "column",
	},
	bottonRightTextEtiquetaContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexDirection: "row",
	},
	containerQrcode: {
		width: "100px",
		height: "300px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		margin: 0,
		marginTop: "105px",
		padding: 0,
	},
	qrCode: {
		width: "55px",
		height: "55px",
	},
	qrCodeContainer: {
		width: "100%",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		color: "black",
	},
	qrCodeContainerTexTitle: {
		fontSize: "84px",
		textTransform: "uppercase",
		fontFamily: "Roboto bold",
	},
	qrCodeContainerTextSubTitle: {
		fontSize: "30px",
	},
	footer: {
		position: "absolute",
		width: "100vw",
		height: "20px",
		bottom: 0,
	},

	containerFooter: {
		width: "100vw",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
	},
	paggingContainer: {
		width: "100%",
		backgroundColor: "black",
		height: "10px",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-evenly",
		alignItems: "center",
	},
	paggingText: {
		alignItems: "flex-end",
		fontSize: "8px",
		paddingHorizontal: "5px",
		fontFamily: "Roboto bold",
		color: "white",
	},
	imgFooterInvetida: {
		height: "100%",
		width: "auto",
		transform: "scaleX(-1)",
	},
	imgFooter: {
		height: "100%",
		width: "auto",
	},
	// textTransform
	TextBoldTitle: {
		fontFamily: "Roboto bold",
		fontSize: "6px",
	},
	TextBoldNumber: {
		fontFamily: "Roboto bold",
		fontSize: "12px",
	},
	TextBoldTitleRight: {
		fontFamily: "Roboto bold",
		fontSize: "6px",
	},
	TextBoldTitleNumber: {
		fontFamily: "Roboto bold",
		fontSize: "14px",
	},
	TextBoldSubTitle: {
		fontFamily: "Roboto bold",
		fontSize: "6px",
	},
	TextBold: {
		fontFamily: "Roboto bold",
		fontSize: "8px",
	},
	TextNormal: {
		fontSize: "5px",
	},
	TextNormalQrCode: {
		fontSize: "4px",
	},
});

const PdfHangTags12x5 = (props) => {
	const vendaItemId = props.item;
	const vendaId = props.venda;
	const [venda, setVenda] = useState(null);
	const [vendaItem, setVendaItem] = useState(null);
	const [loading, setLoading] = useState(true);

	const vendaService = new VendaService();

	useEffect(() => {
		initData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const formatCpfCnPJ = (value) => {
		if (value.length > 11) {
			value =
				value.substring(0,2) +
				"." +
				value.substring(2, 5) +
				"." +
				value.substring(5, 8) +
				"/" +
				value.substring(8, 12) +
				"." +
				value.substring(12);
		} else {
			value =
				value.substring(0,3) +
				"." +
				value.substring(3,6) +
				"." +
				value.substring(6,9) +
				"-" +
				value.substring(9);
		}
		return value;
	};

	const getNomeProduto = (vendaItem) => {
		if (!vendaItem) return "Produto não informado";
		const cultura = vendaItem?.ordemProducao?.produtoFinal?.cultivo?.cultura || "";
		const variedade = vendaItem?.ordemProducao?.produtoFinal?.cultivo?.variedade || "";
		return cultura && variedade
			? `${cultura} ${variedade}`
			: cultura || variedade || "Produto não informado";
	};

	const initData = async () => {
		try {
			if (!vendaId || !vendaItemId) {
				setLoading(false);
				return;
			}

			const vendaData = await vendaService.getById(vendaId);
			if (!vendaData) {
				setLoading(false);
				return;
			}

			setVenda(vendaData);

			const item = vendaData.itens?.find((i) => i.ordemProducaoId === vendaItemId);
			setVendaItem(item);

			setLoading(false);
		} catch (error) {
			console.error("Erro ao carregar dados da venda:", error);
			setLoading(false);
		}
	};


	function checkValid() {
		return props.checkDist === "0" ? true : false;
	}

	function checkDoubleTag() {
		return props.doubleTag === "0" ? true : false;
	}
	//qrcode
	const ids = props.ids;
	function QRCodePage({ id }) {
		const dataUrl = document.getElementById(id).toDataURL();

		return (
			<Page
				size={{ width: 340.15, height: checkDoubleTag() ? 303.32 : 141.66 }}
				style={styles.page}
			>
				<View style={{height: 141.66}}>
					<View style={styles.body}>
						<View style={styles.qrCodeContainer}>
							{/* top etiqueta */}
							<View style={styles.topEtiquetaContainer}>
								<View style={{ height: "50x" }}>
									<View style={styles.logoEmpressaContainer}></View>
								</View>
								<View style={styles.codBarContainer}>
									<Text
										style={{
											alignItems: "center",
											justifyContent: "center",
											textTransform: "uppercase",
										}}
									>
										{getNomeProduto(vendaItem)}
									</Text>
								</View>
								<View style={styles.containerQrcode}>
									<Text style={styles.TextNormalQrCode}>CONHEÇA ORIGEM</Text>
									<Text style={styles.TextNormalQrCode}>DESTE PRODUTO</Text>
									<Image src={dataUrl} style={styles.qrCode} />
									<Text style={styles.TextNormalQrCode}>POR: SISAGRI</Text>
								</View>
							</View>
							{/* botton etiqueta */}
							<View style={styles.bottonEtiquetaContainer}>
								{/* esquerda */}
								<View style={{ marginBottom: "2px" }}>
									<Text style={styles.TextBold}>
										Peso liquido Mínimo: <Text style ={styles.TextBoldNumber}>{`${vendaItem?.ordemProducao?.embalagemProdutoFinal?.quantidade} ${vendaItem?.ordemProducao?.embalagemProdutoFinal?.unidadeMedida?.sigla}`}</Text>
									</Text>
									<Text style={styles.TextBold}>Embalagem: {vendaItem?.ordemProducao?.embalagemProdutoFinal?.nome}</Text>
									<Text style={styles.TextBold}>
										Código de Rastreio: {`${venda?.numeroVenda}-${vendaItem?.ordemProducao?.loteRastreabilidade}`}
									</Text>
								</View>

								<View style={{ marginBottom: "2px" }}>
									<Text style={styles.TextNormal}>Distribuído por {venda?.unidadeDistribuidora?.nome || "Não informado"}</Text>
									<Text style={styles.TextNormal}>
										{venda?.unidadeDistribuidora?.endereco ?
										[(venda.unidadeDistribuidora.endereco.logradouro || venda.unidadeDistribuidora.endereco.endereco), venda.unidadeDistribuidora.endereco.bairro, [venda.unidadeDistribuidora.endereco.cidade, venda.unidadeDistribuidora.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ")
										: ""}
									</Text>
									<Text style={styles.TextNormal}>
										{venda?.unidadeDistribuidora?.cpf_cnpj ?
											(venda.unidadeDistribuidora.cpf_cnpj.length > 11
												? `CNPJ: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`
												: `CPF: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`)
											: ""}
									</Text>
								</View>
								{checkValid() && (
									<View>
										<Text style={styles.TextNormal}>
											Destino {venda?.cliente?.nome || venda?.cliente?.nomeFantasia}
										</Text>
										<Text style={styles.TextNormal}>
											{venda?.cliente?.endereco ? [(venda.cliente.endereco.logradouro || venda.cliente.endereco.endereco), venda.cliente.endereco.bairro, [venda.cliente.endereco.cidade, venda.cliente.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ") : ""}
										</Text>
										<Text style={styles.TextNormal}>
											{venda?.cliente?.cpfCnpj && (venda.cliente.cpfCnpj.length > 11
													? `CNPJ: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`
													: `CPF: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`)}
										</Text>
									</View>
								)}

								<View style={{ marginTop: "2px" }}>
									{vendaItem?.ordemProducao?.dataProducao && (
										<Text style={styles.TextNormal}>
											Data de Embalagem: {new Date(vendaItem?.ordemProducao?.dataProducao).toLocaleDateString("pt-BR")}
										</Text>
									)}

									<Text style={styles.TextNormal}>Data de Entrega: {new Date(venda?.dataExpedicao).toLocaleDateString("pt-BR")}</Text>

									{(vendaItem?.ordemProducao?.dataValidade && props.showExpiryDate) && (
										<Text style={styles.TextNormal}>
											Data de Validade: {new Date(vendaItem?.ordemProducao?.dataValidade).toLocaleDateString("pt-BR")}
										</Text>
									)}

									<Text style={styles.TextBoldTitle}>{vendaItem?.especificacao}</Text>
								</View>
								{/* direita */}
							</View>
						</View>
					</View>
					{/* roda pé  */}
					<View style={styles.footer} fixed>
						<View style={styles.paggingContainer}>
							<Image src={Seta} style={styles.imgFooter} />
							<View style={styles.paggingText}>
								<Text>PRODUTO COM ORIGEM RASTREADA</Text>
							</View>
							<Image src={Seta} style={styles.imgFooterInvetida} />
							<View style={styles.paggingText}>
								<Text>https://www.sisagri.com.br</Text>
							</View>
							<Image src={Seta} style={styles.imgFooterInvetida} />
						</View>
					</View>
				</View>
				{checkDoubleTag() && (
					<>
						<View style={{height: 19.8, backgroundColor: "transparent"}} />
						<View style={{height: 141.66}}>
							<View style={styles.body}>
								<View style={styles.qrCodeContainer}>
									{/* top etiqueta */}
									<View style={styles.topEtiquetaContainer}>
										<View style={{ height: "50x" }}>
											<View style={styles.logoEmpressaContainer}></View>
										</View>
										<View style={styles.codBarContainer}>
											<Text
												style={{
													alignItems: "center",
													justifyContent: "center",
													textTransform: "uppercase",
												}}
											>
												{getNomeProduto(vendaItem)}
											</Text>
										</View>
										<View style={styles.containerQrcode}>
											<Text style={styles.TextNormalQrCode}>CONHEÇA ORIGEM</Text>
											<Text style={styles.TextNormalQrCode}>DESTE PRODUTO</Text>
											<Image src={dataUrl} style={styles.qrCode} />
											<Text style={styles.TextNormalQrCode}>POR: SISAGRI</Text>
										</View>
									</View>
									{/* botton etiqueta */}
									<View style={styles.bottonEtiquetaContainer}>
										{/* esquerda */}
										<View style={{ marginBottom: "2px" }}>
											<Text style={styles.TextBold}>
												Peso liquido Mínimo: <Text style ={styles.TextBoldNumber}>{`${vendaItem?.ordemProducao?.embalagemProdutoFinal?.quantidade} ${vendaItem?.ordemProducao?.embalagemProdutoFinal?.unidadeMedida?.sigla}`}</Text>
											</Text>
											<Text style={styles.TextBold}>Embalagem: {vendaItem?.ordemProducao?.embalagemProdutoFinal?.nome}</Text>
											<Text style={styles.TextBold}>
												Código de Rastreio: {`${venda?.numeroVenda}-${vendaItem?.ordemProducao?.loteRastreabilidade}`}
											</Text>
										</View>

										<View style={{ marginBottom: "2px" }}>
											<Text style={styles.TextNormal}>Distribuído por {venda?.unidadeDistribuidora?.nome || "Não informado"}</Text>
											<Text style={styles.TextNormal}>
												{venda?.unidadeDistribuidora?.endereco ?
										[(venda.unidadeDistribuidora.endereco.logradouro || venda.unidadeDistribuidora.endereco.endereco), venda.unidadeDistribuidora.endereco.bairro, [venda.unidadeDistribuidora.endereco.cidade, venda.unidadeDistribuidora.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ")
										: ""}
											</Text>
											<Text style={styles.TextNormal}>
												{venda?.unidadeDistribuidora?.cpf_cnpj ?
													(venda.unidadeDistribuidora.cpf_cnpj.length > 11
														? `CNPJ: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`
														: `CPF: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`)
													: ""}
											</Text>
										</View>
										{checkValid() && (
											<View>
												<Text style={styles.TextNormal}>
													Destino {venda?.cliente?.nome || venda?.cliente?.nomeFantasia}
												</Text>
												<Text style={styles.TextNormal}>
													{venda?.cliente?.endereco ? [(venda.cliente.endereco.logradouro || venda.cliente.endereco.endereco), venda.cliente.endereco.bairro, [venda.cliente.endereco.cidade, venda.cliente.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ") : ""}
												</Text>
												<Text style={styles.TextNormal}>
													{venda?.cliente?.cpfCnpj && (venda.cliente.cpfCnpj.length > 11
															? `CNPJ: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`
															: `CPF: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`)}
												</Text>
											</View>
										)}

										<View style={{ marginTop: "2px" }}>
											{vendaItem?.ordemProducao?.dataProducao && (
												<Text style={styles.TextNormal}>
													Data de Embalagem: {new Date(vendaItem?.ordemProducao?.dataProducao).toLocaleDateString("pt-BR")}
												</Text>
											)}

											<Text style={styles.TextNormal}>Data de Entrega: {new Date(venda?.dataExpedicao).toLocaleDateString("pt-BR")}</Text>

											{(vendaItem?.ordemProducao?.dataValidade && props.showExpiryDate) && (
												<Text style={styles.TextNormal}>
													Data de Validade: {new Date(vendaItem?.ordemProducao?.dataValidade).toLocaleDateString("pt-BR")}
												</Text>
											)}
											<Text style={styles.TextBoldTitle}>{vendaItem?.especificacao}</Text>
										</View>
										{/* direita */}
									</View>
								</View>
							</View>
							{/* roda pé  */}
							<View style={styles.footer} fixed>
								<View style={styles.paggingContainer}>
									<Image src={Seta} style={styles.imgFooter} />
									<View style={styles.paggingText}>
										<Text>PRODUTO COM ORIGEM RASTREADA</Text>
									</View>
									<Image src={Seta} style={styles.imgFooterInvetida} />
									<View style={styles.paggingText}>
										<Text>https://www.sisagri.com.br</Text>
									</View>
									<Image src={Seta} style={styles.imgFooterInvetida} />
								</View>
							</View>
						</View>
					</>
				)}
			</Page>
		);
	}

	return (
		!loading ?
			<Document>
				{ids.map((id) => (
					<QRCodePage id={id} key={id} />
				))}
			</Document>
			:<Document></Document>
	);
};


export default PdfHangTags12x5;
